import { useTranslation } from 'react-i18next';
import type { PublicTransfer } from '@/lib/transferApi';
import { formatDate, formatMoney } from '@/lib/format';

export default function TransferSummary({ transfer }: { transfer: PublicTransfer }) {
  const { t, i18n } = useTranslation();

  const rows = [
    { label: t('flow.beneficiary'), value: transfer.beneficiaryName },
    { label: t('flow.bank'), value: transfer.bank.name },
    { label: t('flow.reference'), value: transfer.reference },
    { label: t('flow.date'), value: formatDate(transfer.createdAt, i18n.language, true) },
  ];

  return (
    <div className="rounded-2xl border border-background-200 bg-background-100 p-4 md:p-5">
      <p className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-foreground-500 font-label">
        {t('flow.amount')}
      </p>
      <p className="mt-1.5 text-[30px] md:text-[34px] leading-none font-semibold text-foreground-950 tabular font-heading">
        {formatMoney(transfer.amount, transfer.currency, i18n.language)}
      </p>

      <dl className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-2.5">
        {rows.map((row) => (
          <div key={row.label} className="min-w-0">
            <dt className="text-[10.5px] font-semibold uppercase tracking-[0.1em] text-foreground-400 font-label">
              {row.label}
            </dt>
            <dd className="mt-0.5 text-[12.5px] font-semibold text-foreground-900 break-words">{row.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}